import React from 'react';
import { WrappedBase } from './WrappedBase';

import { createCalculatorStore } from '../store';
import { buildInitialState } from '../initialState';
import CalculatorPageContainer from '../containers/CalculatorPageContainer';

interface Props {
  pricePerPod: number;
  locale: string;
  translatedMessages: Record<string, string>;
}

export const CalculatorPageWrapped: React.FC<Props> = props => {
  const { pricePerPod, locale, translatedMessages } = props;
  return (
    <WrappedBase
      store={createCalculatorStore({
        initialState: buildInitialState({ pricePerPod }),
      })}
      locale={locale}
      translatedMessages={translatedMessages}
    >
      <CalculatorPageContainer {...props} />
    </WrappedBase>
  );
};
